import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const PermissionsContext = createContext(null);

export const usePermissions = () => useContext(PermissionsContext);

export const PermissionsProvider = ({ children }) => {
  const { user } = useAuth();
  const [permissions, setPermissions] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { setPermissions(null); setLoading(false); return; }
    setLoading(true);
    axios.get(`${API_URL}/api/users/me/permissions`, { withCredentials: true })
      .then(({ data }) => setPermissions(data.permissions || {}))
      .catch(() => setPermissions({}))
      .finally(() => setLoading(false));
  }, [user]);

  const can = (module, action) => {
    if (user?.role === 'Super Admin') return true;
    return !!(permissions && permissions[module] && permissions[module][action]);
  };

  return (
    <PermissionsContext.Provider value={{ permissions, loading, can }}>
      {children}
    </PermissionsContext.Provider>
  );
};
